
import { Vue } from "vue-class-component";

export default class PreLoader extends Vue {}
